import React, { useState, useEffect } from "react";
import axios from "axios";
import Swal from "sweetalert2";
import Modal from "react-bootstrap/Modal";
import {
  Container,
  Row,
  Col,
  Form,
  Button,
  ProgressBar,
} from "react-bootstrap";
import { useParams } from "react-router-dom";
import Sub_header from "../Sub_header";
import exportValue from "../../apiconfig";
import Left_panel from "../Left_panel";
import Moment from "react-moment";
import { saveAs } from "file-saver";

const Customers_info = () => {
  const { customer_id } = useParams();

  const [state, setState] = useState({ isLoading: true, user_info: {} });
  console.log("state == ", state);
  const [limitstate, setlimit] = useState({
    credit_limit: 0,
    credit_limit_range: 0,
  });
  const [isLoading, setIsLoading] = useState(false);
  const [newState, setNewState] = useState({
    customer_id: "",
    amount: "",
    mode: 1,
    cod_wallet_balance: 0,
    remarks: "",
  });
  const [modalState, setModalState] = useState({ show: false });
  const [passwordstate, setpasswordState] = React.useState({
    customer_id: "",
    password: "",
  });
  const [passwordmodal, setpasswordmodal] = React.useState({ show: false });
  const [creditState, setCreditState] = useState({
    customer_id: "",
    amount: 0,
    order_id: "",
  });
  const [modalcredit, setModalCreditState] = useState({ show: false });
  const [isSidebarOpen, setIsSidebarOpen] = React.useState(false);
  const [typestate, settypestate] = useState({ type: "credit" });
  const [jpstate, setjpstate] = useState({ jp_id: "", jp_otp: "" });
  const [amstate, setamstate] = useState({ am_id: "", am_otp: "" });
  const [ndrstate, setndrstate] = useState({ ndr_id: "", ndr_otp: "" });
  const [month, setMonth] = useState(""); // Stores selected month
  const [year, setYear] = useState(new Date().getFullYear()); // Dynamically set current year
  const [loading, setLoading] = useState(false); // Loader state
  const [shipmentData, setShipmentData] = useState(null); // Stores API response
  const [message, setMessage] = useState("CLICK ON SUBMIT BUTTON TO GET DATA");
  const [ivrnumberstate, setivrnumberstate] = useState({ number: "" });
  const [countrylist, setcountrylist] = React.useState([]);
  const [statelist, setstatelist] = React.useState([]);
  const [citylist, setcitylist] = React.useState([]);

  const [vasStatus, setVasStatus] = useState({
    delivery_updates: false,
    human_ndr: false,
    cod_verification: false,
    cod_shield: false,
    rto_shield: false,
    ivr_number_requested: 0,
    ivr_number: "",
    ivr_language: "",
  });
  const [vasPrice, setVasPrice] = useState({
    delivery_update_price: 0,
    cod_verification_price: 0,
    cod_shield_price: 0,
    rto_shield_price: 0,
  });
  const [bulkPricingFile, setBulkPricingFile] = useState(null);
  const [bulkPricingLoading, setBulkPricingLoading] = useState(false);
  const [subscription, setSubscription] = useState({
    plan_name: "",
    is_custom: false,

    monthly_price: 0,

    free_orders: 0,

    delivery_update_price: 0,

    cod_verification_price: 0,

    cod_shield_price: 0,

    rto_shield_price: 0,

    trueweight_price: 0,
  });

  const toggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen);
    const homeSection = document.querySelector(".home-section");
    if (homeSection) {
      homeSection.classList.toggle("sidebar-closed");
    }
  };
  useEffect(() => {
    getUsersInfo();
    countryList();
    fetchVasStatus();
    fetchVasPrices();
    getSellerVASSettings();
  }, []);

  const Toast = Swal.mixin({
    toast: true,
    position: "bottom-end",
    showConfirmButton: false,
    timer: 5000,
  });

  const fetchVasStatus = async () => {
    try {
      let full_api =
        exportValue.host +
        "/" +
        exportValue.version +
        "/" +
        exportValue.api +
        "/get_vas_status";
      let sendData = { customer_id: customer_id };

      const res = await axios.post(full_api, sendData, {
        headers: exportValue.headers,
      });
      if (res.data && res.data.status) {
        setVasStatus(res.data.status);
      }
    } catch (err) {
      console.error("Failed to fetch VAS status", err);
    }
  };

  const fetchVasPrices = async () => {
    try {
      let full_api =
        exportValue.host +
        "/" +
        exportValue.version +
        "/" +
        exportValue.api +
        "/get_vas_prices";
      let sendData = { customer_id: customer_id };

      const res = await axios.post(full_api, sendData, {
        headers: exportValue.headers,
      });
      setVasPrice({
        delivery_update_price: res.data.delivery_update_price,
        cod_verification_price: res.data.cod_verification_price,
        cod_shield_price: res.data.cod_shield_price,
        rto_shield_price: res.data.rto_shield_price,
      });
    } catch (err) {
      console.error("Failed to fetch VAS status", err);
    }
  };

  const getUsersInfo = () => {
    setIsLoading(true);
    let full_api =
      exportValue.host +
      "/" +
      exportValue.version +
      "/" +
      exportValue.api +
      `/user_detail`;
    let sendData = { customer_id: customer_id };

    // console.log("bb", sendData);
    axios
      .post(full_api, sendData, { headers: exportValue.headers })
      .then((res) => {
        setIsLoading(false);
        if (res.data.output.length == 1) {
          if (res.data.output[0].country && res.data.output[0].country != "") {
            handleSelectCountry({
              target: { name: "country", value: res.data.output[0].country },
            });
          }

          // Preload city list if state is set
          if (res.data.output[0].state && res.data.output[0].state != "") {
            handleSelectState({
              target: { name: "state", value: res.data.output[0].state },
            });
          }
          setState({
            ...state,
            user_info: res.data.output[0],
            isLoading: false,
          });
        }
      })
      .catch((e) => {
        setIsLoading(false);
      });
  };

  const countryList = () => {
    let full_api = exportValue.apiUrl + `/country/country_list`;
    let sendData = {};
    axios
      .post(full_api, sendData, { headers: exportValue.headers })
      .then((res) => {
        setcountrylist(res.data.output);
      })
      .catch((e) => {
        // setIsLoading(false)
      });
  };
  const handleSelectCountry = (e) => {
    let userTemp = { ...state.user_info };
    // console.log("userTemp ", userTemp[e.target.name]);
    userTemp[e.target.name] = e.target.value;
    setState({ ...state, user_info: userTemp });

    let full_api = exportValue.apiUrl + `/country/state_list`;
    let sendData = { t_country_id: e.target.value };
    axios
      .post(full_api, sendData, { headers: exportValue.headers })
      .then((res) => {
        setstatelist(res.data.output);
      })
      .catch((e) => {
        // setIsLoading(false)
      });
  };
  const handleSelectState = (e) => {
    let userTemp = { ...state.user_info };
    // console.log("userTemp ", userTemp[e.target.name]);
    userTemp[e.target.name] = e.target.value;
    setState({ ...state, user_info: userTemp });

    let full_api = exportValue.apiUrl + `/country/all_city_list`;
    let sendData = { state_id: e.target.value };
    axios
      .post(full_api, sendData, { headers: exportValue.headers })
      .then((res) => {
        setcitylist(res.data.output);
      })
      .catch((e) => {
        // setIsLoading(false)
      });
  };

  const handleSelectCity = (e) => {
    let userTemp = { ...state.user_info };
    // console.log("userTemp ", userTemp[e.target.name]);
    userTemp[e.target.name] = e.target.value;
    setState({ ...state, user_info: userTemp });
  };

  const updateUsersInfo = () => {
    setIsLoading(true);
    let full_api =
      exportValue.host +
      "/" +
      exportValue.version +
      "/" +
      exportValue.api +
      `/user_update`;
    let sendData = state.user_info;

    // console.log("bb", sendData);
    axios
      .post(full_api, sendData, { headers: exportValue.headers })
      .then((res) => {
        console.log("res", res);
        if (res.data.status == 200) {
          Toast.fire({
            background: "#10b93b",
            type: "success",
            title: "Updated Successfully !",
            color: "white",
          });
        }
      })
      .catch((e) => {
        setIsLoading(false);
      });
  };

  const inputEditHandleChange = (e) => {
    console.log("e", e);
    // console.log("type", e.target.type);
    // console.log("name", e.target.name);
    // console.log("value", e.target.value);
    // console.log("file", e.target.files);

    let userTemp = { ...state.user_info };
    // console.log("userTemp ", userTemp[e.target.name]);
    userTemp[e.target.name] = e.target.value;
    setState({ ...state, user_info: userTemp });
  };

  const handlecreditlimit = (e) => {
    setlimit({ credit_limit_range: e.target.value });
    let userTemp = { ...state.user_info };
    // console.log("userTemp ", userTemp[e.target.name]);
    userTemp[e.target.name] = e.target.value;
    setState({ ...state, user_info: userTemp });
  };

  const handlenotificationprices = (e) => {
    let userTemp = { ...state.user_info };
    // console.log("userTemp ", userTemp[e.target.name]);
    userTemp[e.target.name] = e.target.value;
    setState({ ...state, user_info: userTemp });
  };

  const handleivrNumber = (e) => {
    const { name, value } = e.target;

    setState((prev) => ({
      ...prev,
      user_info: {
        ...prev.user_info,
        [name]: value,
      },
    }));
  };

  const setCreditlimit = () => {
    let full_api =
      exportValue.host +
      "/" +
      exportValue.version +
      "/" +
      exportValue.api +
      `/user_credit_limit_update`;
    let sendData = {
      customer_id: customer_id,
      credit_limit_range: limitstate.credit_limit_range,
    };
    console.log("sendData ==", sendData);
    // if(limitstate.credit_limit_range!=0 ){
    axios
      .post(full_api, sendData, { headers: exportValue.headers })
      .then((res) => {
        console.log("res", res);
        if (res.data.status == 200) {
          Toast.fire({
            background: "#10b93b",
            type: "success",
            title: "Updated Successfully !",
            color: "white",
          });
          getUsersInfo();
        }
      })
      .catch((e) => {
        Toast.fire({
          background: "#10b93b",
          type: "success",
          title: "Something Went Wrong",
          color: "white",
        });
      });
    // }else{
    //     Toast.fire({
    //         background: "#10b93b",
    //         type: 'success',
    //         title: "Please Fill credit limit value greater than zero",
    //         color: "white"
    //     });
    // }
  };

  const updateIvrNumber = () => {
    if (!state.user_info.ivr_number) {
      Toast.fire({
        background: "#f44336",
        icon: "error",
        title: "Please enter IVR number",
        color: "white",
      });
      return;
    }

    let full_api =
      exportValue.host +
      "/" +
      exportValue.version +
      "/" +
      exportValue.api +
      `/user_ivr_number_update`;

    let sendData = {
      customer_id: customer_id,
      ivr_number: state.user_info.ivr_number,
    };

    axios
      .post(full_api, sendData, { headers: exportValue.headers })
      .then((res) => {
        if (res.data.status === 200) {
          Toast.fire({
            background: "#10b93b",
            icon: "success",
            title: "Updated Successfully!",
            color: "white",
          });
          getUsersInfo();
          fetchVasStatus();
          fetchVasPrices();
        }
      })
      .catch(() => {
        Toast.fire({
          background: "#f44336",
          icon: "error",
          title: "Something went wrong",
          color: "white",
        });
      });
  };
  const addMoneyWallet = (user) => {
    console.log(user);
    setNewState({
      ...newState,
      customer_id: user.customer_id,
      amount: 0,
      cod_wallet_balance: user.cod_wallet_balance,
      mode: 1,
      remarks: "",
    });
    setModalState({ show: true });
  };
  const submitAddWalet = () => {
    console.log("newState ", newState);
    if (newState.amount != "") {
      if (newState.remarks != "") {
        let flag = true;
        if (
          newState.mode == 2 &&
          newState.amount > newState.cod_wallet_balance
        ) {
          flag = false;
          Toast.fire({
            background: "#e63900",
            type: "error",
            title: "Insuficient balance",
            color: "white",
          });
        }
        if (flag) {
          setIsLoading(true);
          let full_api =
            exportValue.host +
            "/" +
            exportValue.version +
            "/" +
            exportValue.api +
            `/user_wallet_update`;
          let sendData = { newState, type: typestate.type };
          axios
            .post(full_api, sendData, { headers: exportValue.headers })
            .then((res) => {
              if (
                typestate.type == "credit" ||
                typestate.type == "recharge" ||
                typestate.type == "claim"
              ) {
                Toast.fire({
                  background: "#e63900",
                  type: "success",
                  title: "Wallet Balance Added",
                  color: "white",
                });
              } else {
                Toast.fire({
                  background: "#e63900",
                  type: "success",
                  title: "Wallet Balance Deducted",
                  color: "white",
                });
              }

              setIsLoading(false);
              setModalState({ show: false });
              // getUsersList(0, true);
            })
            .catch((e) => {
              setIsLoading(false);
            });
        }
      } else {
        Toast.fire({
          background: "#e63900",
          type: "error",
          title: "Please fill remark",
          color: "white",
        });
      }
    } else {
      Toast.fire({
        background: "#e63900",
        type: "error",
        title: "Please add amount",
        color: "white",
      });
    }
  };

  const inputHandleChange = (e) => {
    console.log("e", e);
    // console.log("type", e.target.type);
    // console.log("name", e.target.name);
    // console.log("value", e.target.value);
    // console.log("file", e.target.files);
    if (e.target.type == "file") {
      setNewState({ ...newState, [e.target.name]: e.target.files });
    } else {
      setNewState({ ...newState, [e.target.name]: e.target.value });
    }
  };
  const openpasswordModal = (user) => {
    setpasswordState({ ...passwordstate, customer_id: user.customer_id });
    setpasswordmodal({ show: true });
  };
  const closeModalpassword = () => {
    setpasswordState({ ...passwordstate, customer_id: "", password: "" });
    setpasswordmodal({ show: false });
  };

  const passwordchange = (e) => {
    setpasswordState({ ...passwordstate, password: e.target.value });
  };

  const submitPassword = () => {
    if (passwordstate.password != "") {
      let full_api =
        exportValue.host +
        "/" +
        exportValue.version +
        "/" +
        exportValue.api +
        `/customer_temp_password_update`;
      let sendData = {
        customer_id: passwordstate.customer_id,
        password: passwordstate.password,
      };
      console.log("send_data === ", sendData);
      axios
        .post(full_api, sendData, { headers: exportValue.headers })
        .then((res) => {
          if (res.data.status == true) {
            setpasswordmodal({ show: false });
            setpasswordState({
              ...passwordstate,
              customer_id: "",
              password: "",
            });

            Toast.fire({
              background: "#e63900",
              type: "error",
              title: "Password Created and Valid for Next 30 minutes",
              color: "white",
            });
          }
        })
        .catch((e) => {
          // setIsLoading(false)
          Toast.fire({
            background: "#e63900",
            type: "error",
            title: "Something Went Wrong",
            color: "white",
          });
        });
    } else {
      Toast.fire({
        background: "#e63900",
        type: "error",
        title: "Please Fill Password",
        color: "white",
      });
    }
  };

  const skip_kyc = (user) => {
    let full_api =
      exportValue.host +
      "/" +
      exportValue.version +
      "/" +
      exportValue.api +
      `/customer_skip_kyc`;
    let sendData = { customer_id: user.customer_id };
    console.log("send_data === ", sendData);
    axios
      .post(full_api, sendData, { headers: exportValue.headers })
      .then((res) => {
        if (res.data.status == true) {
          Toast.fire({
            background: "#e63900",
            type: "error",
            title: "KYC Skipped for this Customer !",
            color: "white",
          });
        } else {
          Toast.fire({
            background: "#e63900",
            type: "error",
            title: "Something Went Wrong !",
            color: "white",
          });
        }
      })
      .catch((e) => {
        // setIsLoading(false)
        Toast.fire({
          background: "#e63900",
          type: "error",
          title: "Something Went Wrong",
          color: "white",
        });
      });
  };
  const addCreditnote = (user) => {
    console.log(user);
    setCreditState({
      ...creditState,
      customer_id: user.customer_id,
      amount: 0,
    });
    setModalCreditState({ show: true });
  };
  const inputHandleChangecredit = (e) => {
    console.log("e", e);
    setCreditState({ ...creditState, [e.target.name]: e.target.value });
  };
  const submitCreditNote = () => {
    console.log("creditState ", creditState);
    if (creditState.amount > 0) {
      if (creditState.order_id != "") {
        let full_api =
          exportValue.host +
          "/" +
          exportValue.version +
          "/" +
          exportValue.api +
          `/user_credit_wallet_update`;
        let sendData = creditState;
        axios
          .post(full_api, sendData, { headers: exportValue.headers })
          .then((res) => {
            if (res.data.status == true) {
              setModalCreditState({ show: false });
              // getUsersList(0, true);
              getUsersInfo();
              Toast.fire({
                background: "#e63900",
                type: "success",
                title: res.data.message,
                color: "white",
              });
            } else {
              Toast.fire({
                background: "#e63900",
                type: "error",
                title: res.data.message,
                color: "white",
              });
            }
          })
          .catch((e) => {
            // setIsLoading(false)
          });
      } else {
        Toast.fire({
          background: "#e63900",
          type: "error",
          title: "Please FilL Order ID",
          color: "white",
        });
      }
    } else {
      Toast.fire({
        background: "#e63900",
        type: "error",
        title: "Please add amount",
        color: "white",
      });
    }
  };
  const inputChangetype = (e) => {
    settypestate({ ...typestate, type: e.target.value });
  };

  const handlejp = (e) => {
    setjpstate({ ...jpstate, [e.target.name]: e.target.value });
  };

  const updateJp = () => {
    if (jpstate.jp_otp != "") {
      if (jpstate.jp_id != "") {
        let full_api =
          exportValue.host +
          "/" +
          exportValue.version +
          "/" +
          exportValue.api +
          `/update_user_jp`;
        let sendData = {
          jp_otp: parseInt(jpstate.jp_otp),
          jp_id: jpstate.jp_id,
          customer_id: customer_id,
        };
        axios
          .post(full_api, sendData, { headers: exportValue.headers })
          .then((res) => {
            if (res.data.status == true) {
              Toast.fire({
                background: "#e63900",
                type: "success",
                title: "Update Successfully",
                color: "white",
              });
              window.location.reload();
            } else {
              Toast.fire({
                background: "#e63900",
                type: "error",
                title: res.data.message,
                color: "white",
              });
            }
          })
          .catch((e) => {
            // setIsLoading(false)
          });
      } else {
        Toast.fire({
          background: "#e63900",
          type: "error",
          title: "Please Fill Referral ID",
          color: "white",
        });
      }
    } else {
      Toast.fire({
        background: "#e63900",
        type: "error",
        title: "Please fill OTP",
        color: "white",
      });
    }
  };

  const handleam = (e) => {
    setamstate({ ...amstate, [e.target.name]: e.target.value });
  };

  const updateam = () => {
    if (amstate.am_otp != "") {
      if (amstate.am_id != "") {
        let full_api =
          exportValue.host +
          "/" +
          exportValue.version +
          "/" +
          exportValue.api +
          `/update_user_am`;
        let sendData = {
          am_otp: parseInt(amstate.am_otp),
          am_id: amstate.am_id,
          customer_id: customer_id,
        };
        axios
          .post(full_api, sendData, { headers: exportValue.headers })
          .then((res) => {
            if (res.data.status == true) {
              Toast.fire({
                background: "#e63900",
                type: "success",
                title: "Update Successfully",
                color: "white",
              });
              window.location.reload();
            } else {
              Toast.fire({
                background: "#e63900",
                type: "error",
                title: res.data.message,
                color: "white",
              });
            }
          })
          .catch((e) => {
            // setIsLoading(false)
          });
      } else {
        Toast.fire({
          background: "#e63900",
          type: "error",
          title: "Please Fill Referral ID",
          color: "white",
        });
      }
    } else {
      Toast.fire({
        background: "#e63900",
        type: "error",
        title: "Please fill OTP",
        color: "white",
      });
    }
  };

  const handlendr = (e) => {
    setndrstate({ ...ndrstate, [e.target.name]: e.target.value });
  };

  const sendOtp = async (action) => {
    let full_api =
      exportValue.host +
      "/" +
      exportValue.version +
      "/" +
      exportValue.api +
      `/send_otp_admin`;
    let sendData = { action: action };
    axios
      .post(full_api, sendData, { headers: exportValue.headers })
      .then((res) => {
        if (res.data.success == true) {
          Toast.fire({
            background: "#e63900",
            type: "success",
            title: res.data.message,
            color: "white",
          });
          //   window.location.reload();
        } else {
          Toast.fire({
            background: "#e63900",
            type: "error",
            title: res.data.message,
            color: "white",
          });
        }
      })
      .catch((e) => {
        // setIsLoading(false)
      });
  };

  const updatendr = () => {
    if (ndrstate.ndr_otp != "") {
      if (ndrstate.ndr_id != "") {
        let full_api =
          exportValue.host +
          "/" +
          exportValue.version +
          "/" +
          exportValue.api +
          `/update_user_ndr`;
        let sendData = {
          ndr_otp: parseInt(ndrstate.ndr_otp),
          ndr_id: ndrstate.ndr_id,
          customer_id: customer_id,
        };
        axios
          .post(full_api, sendData, { headers: exportValue.headers })
          .then((res) => {
            if (res.data.status == true) {
              Toast.fire({
                background: "#e63900",
                type: "success",
                title: "Update Successfully",
                color: "white",
              });
              window.location.reload();
            } else {
              Toast.fire({
                background: "#e63900",
                type: "error",
                title: res.data.message,
                color: "white",
              });
            }
          })
          .catch((e) => {
            // setIsLoading(false)
          });
      } else {
        Toast.fire({
          background: "#e63900",
          type: "error",
          title: "Please Fill Referral ID",
          color: "white",
        });
      }
    } else {
      Toast.fire({
        background: "#e63900",
        type: "error",
        title: "Please fill OTP",
        color: "white",
      });
    }
  };

  const fetchData = async () => {
    if (!month || !year) {
      alert("Please select month and year");
      return;
    }

    setLoading(true); // Show loader
    setMessage(""); // Remove initial message

    try {
      let full_api =
        exportValue.host +
        "/" +
        exportValue.version +
        "/" +
        exportValue.api +
        `/shipments_customer_detail`;
      const response = await axios.get(full_api, {
        params: { month, year, customer_id: customer_id }, // Pass customer_id dynamically
      });

      setShipmentData(response.data); // Store API response
    } catch (error) {
      console.error("Error fetching shipment data:", error);
    }

    setLoading(false); // Hide loader
  };

  const handleToggle = async (key) => {
    const updatedValue = !vasStatus[key];
    const updatedStatus = { ...vasStatus, [key]: updatedValue };
    setVasStatus(updatedStatus);

    try {
      let full_api =
        exportValue.host +
        "/" +
        exportValue.version +
        "/" +
        exportValue.api +
        "/update_vas";
      let sendData = { customer_id: customer_id, [key]: updatedValue };
      await axios.post(full_api, sendData, { headers: exportValue.headers });
    } catch (err) {
      console.error("Failed to update VAS:", err);
    }
  };

  const downloadExcel = async () => {
    try {
      let sendData = { customer_id: customer_id };
      const full_api =
        exportValue.host +
        "/" +
        exportValue.version +
        "/" +
        exportValue.api +
        `/download_bulk_pricing_excel_customer`;

      const response = await axios.post(full_api, sendData, {
        headers: exportValue.headers,
        responseType: "blob",
      });

      const blob = new Blob([response.data], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });

      saveAs(blob, "Customer_Bulk_Pricing.xlsx");
    } catch (e) {
      console.log(e);

      Swal.fire({
        icon: "error",
        title: "Failed",
        text: "Unable to download file",
      });
    }
  };

  const uploadBulkPricingExcel = async () => {
    try {
      if (!bulkPricingFile) {
        const Toast = Swal.mixin({
          toast: true,
          position: "bottom-end",
          showConfirmButton: false,
          timer: 3000,
        });

        Toast.fire({
          background: "#206bc4",
          icon: "error",
          title: "Please select excel file",
          color: "white",
        });

        return;
      }

      setBulkPricingLoading(true);

      const formData = new FormData();

      formData.append("file", bulkPricingFile);
      formData.append("customer_id", customer_id);

      let full_api =
        exportValue.host +
        "/" +
        exportValue.version +
        "/" +
        exportValue.api +
        `/upload_bulk_pricing_excel_customer`;

      const response = await axios.post(full_api, formData, {
        headers: {
          ...exportValue.headers,
          "Content-Type": "multipart/form-data",
        },
      });

      setBulkPricingLoading(false);

      if (response.data.status) {
        const modal = document.getElementById("bulkPricingUploadModalCustomer");

        if (modal) {
          const modalInstance = window.bootstrap.Modal.getInstance(modal);

          if (modalInstance) {
            modalInstance.hide();
          }
        }

        // localStorage.setItem(
        //   "bulk_pricing_logs",
        //   JSON.stringify(response.data.logs)
        // );

        // window.location.href = "/bulk_pricing_upload_log";
        const Toast = Swal.mixin({
          toast: true,
          position: "bottom-end",
          showConfirmButton: false,
          timer: 3000,
        });

        Toast.fire({
          background: "#206bc4",
          icon: "success",
          title: "Uploaded Successfully",
          color: "white",
        });
        setTimeout(() => {
          window.location.reload();
        }, 1000);
      } else {
        const Toast = Swal.mixin({
          toast: true,
          position: "bottom-end",
          showConfirmButton: false,
          timer: 3000,
        });

        Toast.fire({
          background: "#206bc4",
          icon: "error",
          title: response.data.message,
          color: "white",
        });
      }
    } catch (e) {
      console.log(e);

      setBulkPricingLoading(false);

      const Toast = Swal.mixin({
        toast: true,
        position: "bottom-end",
        showConfirmButton: false,
        timer: 3000,
      });

      Toast.fire({
        background: "#206bc4",
        icon: "error",
        title: "Something went wrong",
        color: "white",
      });
    }
  };

  const handleSubscriptionChange = (e) => {
    setSubscription({
      ...subscription,
      [e.target.name]: e.target.value,
    });
  };

  const getSellerVASSettings = () => {
    axios
      .post(
        exportValue.host +
          "/" +
          exportValue.version +
          "/" +
          exportValue.api +
          "/get_seller_vas_settings",
        {
          customer_id: customer_id,
        },
        {
          headers: exportValue.headers,
        }
      )
      .then((res) => {
        if (res.data.status) {
          setSubscription(res.data.output);
        }
      });
  };

  const updateCustomPricing = () => {
    axios
      .post(
        exportValue.host +
          "/" +
          exportValue.version +
          "/" +
          exportValue.api +
          "/update_custom_vas_settings",

        {
          customer_id: customer_id,

          ...subscription,
        },

        {
          headers: exportValue.headers,
        }
      )
      .then((res) => {
        if (res.data.status) {
          Toast.fire({
            icon: "success",

            title: res.data.message,
          });

          getSellerVASSettings();
        } else {
          Toast.fire({
            icon: "error",

            title: res.data.message,
          });
        }
      });
  };

  return (
    <div>
      <div class="modal" id="Mobile_Referred">
        <div class="modal-dialog modal-fullscreen">
          <div class="modal-content">
            <div class="modal-header">
              <h4 class="modal-title">Referred By Update</h4>
              <button
                type="button"
                class="btn-close"
                data-bs-dismiss="modal"
              ></button>
            </div>
            <div class="modal-body">
              <div class="row justify-content-center">
                <div class="col-12 col-md-4">
                  <h2>Verify Your Identity</h2>
                  <p>
                    Please verify your identity. We will send an OTP on admin
                    mobile number. Please confirm the OTP first.
                  </p>
                  <div class="d-grid">
                    <a
                      class="btn btn-danger btn-block"
                      onClick={(e) => sendOtp(1)}
                    >
                      Send OTP
                    </a>
                  </div>
                  <div class="card mt-3">
                    <div class="card-body">
                      <div class="mb-3 mt-3">
                        <label for="email" class="form-label">
                          Enter six digit OTP:
                        </label>
                        <input
                          type="number"
                          class="form-control"
                          id="email"
                          placeholder="Enter six digit OTP"
                          name="jp_otp"
                          onChange={(e) => handlejp(e)}
                        />
                      </div>

                      <div class="mb-3 mt-3">
                        <label for="email" class="form-label">
                          Update Referred ID:
                        </label>
                        <input
                          type="text"
                          class="form-control"
                          id="email"
                          placeholder="Enter new Referred ID"
                          name="jp_id"
                          onChange={(e) => handlejp(e)}
                        />
                      </div>

                      <div class="d-grid">
                        <a
                          onClick={(e) => updateJp(e)}
                          style={{ cursor: "pointer" }}
                          class="btn btn-primary btn-block"
                        >
                          Update
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* <!-- Confirm Mobile_Account_manger number Admin The Modal --> */}
      <div class="modal" id="Mobile_Account">
        <div class="modal-dialog modal-fullscreen">
          <div class="modal-content">
            <div class="modal-header">
              <h4 class="modal-title">Account Manager Update</h4>
              <button
                type="button"
                class="btn-close"
                data-bs-dismiss="modal"
              ></button>
            </div>
            <div class="modal-body">
              <div class="row justify-content-center">
                <div class="col-12 col-md-4">
                  <h2>Verify Your Identity</h2>
                  <p>
                    Please verify your identity. We will send an OTP on admin
                    mobile number. Please confirm the OTP first.
                  </p>
                  <div class="d-grid">
                    <a
                      class="btn btn-danger btn-block"
                      onClick={(e) => sendOtp(2)}
                    >
                      Send OTP
                    </a>
                  </div>
                  <div class="card mt-3">
                    <div class="card-body">
                      <div class="mb-3 mt-3">
                        <label for="email" class="form-label">
                          Enter six digit OTP:
                        </label>
                        <input
                          type="number"
                          class="form-control"
                          id="email"
                          placeholder="Enter six digit OTP"
                          name="am_otp"
                          onChange={(e) => handleam(e)}
                        />
                      </div>

                      <div class="mb-3 mt-3">
                        <label for="email" class="form-label">
                          Update Account Manager ID:
                        </label>
                        <input
                          type="text"
                          class="form-control"
                          id="email"
                          placeholder="Enter new Account Manager ID"
                          name="am_id"
                          onChange={(e) => handleam(e)}
                        />
                      </div>

                      <div class="d-grid">
                        <a
                          onClick={(e) => updateam(e)}
                          style={{ cursor: "pointer" }}
                          class="btn btn-primary btn-block"
                        >
                          Update
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* <!-- Confirm Mobile_NDR_Manger number Admin The Modal --> */}
      <div class="modal" id="Mobile_NDR_Manger">
        <div class="modal-dialog modal-fullscreen">
          <div class="modal-content">
            <div class="modal-header">
              <h4 class="modal-title">NDR Manager Update</h4>
              <button
                type="button"
                class="btn-close"
                data-bs-dismiss="modal"
              ></button>
            </div>
            <div class="modal-body">
              <div class="row justify-content-center">
                <div class="col-12 col-md-4">
                  <h2>Verify Your Identity</h2>
                  <p>
                    Please verify your identity. We will send an OTP on admin
                    mobile number. Please confirm the OTP first.
                  </p>
                  <div class="d-grid">
                    <a
                      class="btn btn-danger btn-block"
                      onClick={(e) => sendOtp(3)}
                    >
                      Send OTP
                    </a>
                  </div>
                  <div class="card mt-3">
                    <div class="card-body">
                      <div class="mb-3 mt-3">
                        <label for="email" class="form-label">
                          Enter six digit OTP:
                        </label>
                        <input
                          type="number"
                          class="form-control"
                          id="email"
                          placeholder="Enter six digit OTP"
                          name="ndr_otp"
                          onChange={(e) => handlendr(e)}
                        />
                      </div>

                      <div class="mb-3 mt-3">
                        <label for="email" class="form-label">
                          Update NDR Manager ID:
                        </label>
                        <input
                          type="text"
                          class="form-control"
                          id="email"
                          placeholder="Enter new NDR Manager ID"
                          name="ndr_id"
                          onChange={(e) => handlendr(e)}
                        />
                      </div>

                      <div class="d-grid">
                        <a
                          onClick={(e) => updatendr(e)}
                          style={{ cursor: "pointer" }}
                          class="btn btn-primary btn-block"
                        >
                          Update
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Modal
        show={modalcredit.show}
        onHide={() => setModalCreditState({ show: false })}
      >
        <Modal.Header closeButton>
          <Modal.Title>Add Money</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="row">
            <div className="col-md-12 mb-3">
              <label for="email">Amount</label>
              <input
                className="form-control"
                id="first_name"
                type="number"
                placeholder=""
                name="amount"
                onChange={(e) => inputHandleChangecredit(e)}
                required
              />
              {/* <span>*Please fill </span> */}
            </div>
            <div className="col-md-12 mb-3">
              <label for="email">Order ID</label>
              <br />
              <input
                id="first_name"
                type="text"
                className="form-control"
                name="order_id"
                onChange={(e) => inputHandleChangecredit(e)}
                value={creditState.order_id}
              />
              <br />
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="secondary"
            onClick={() => setModalCreditState({ show: false })}
          >
            Cancel
          </Button>
          <Button variant="primary" onClick={() => submitCreditNote()}>
            Pay
          </Button>
        </Modal.Footer>
      </Modal>

      <Modal
        show={modalState.show}
        onHide={() => setModalState({ show: false })}
      >
        <Modal.Header closeButton>
          <Modal.Title>Add Money</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="row">
            <div className="col-md-12 mb-3">
              <label for="email">Amount</label>
              <input
                className="form-control"
                id="first_name"
                type="number"
                placeholder=""
                name="amount"
                onChange={(e) => inputHandleChange(e)}
                required
              />
              <span>*Please fill </span>
            </div>

            <div className="col-md-12 mb-3">
              <label for="email">Remarks</label>
              <input
                className="form-control"
                id="first_name"
                type="text"
                placeholder=""
                name="remarks"
                onChange={(e) => inputHandleChange(e)}
                required
              />
              <span>*Please fill </span>
            </div>
            <div className="col-md-12 mb-3">
              <label for="type">Select Type</label>
              <select
                className="form-control"
                onChange={(e) => inputChangetype(e)}
              >
                <option value="credit">Credit</option>
                <option value="debit">Debit</option>
                <option value="recharge">Recharge</option>
                <option value="claim">Claims</option>
              </select>
            </div>
            <div className="col-md-12 mb-3">
              <label for="email">Payment Mode</label>
              <br />
              <input
                id="first_name"
                type="radio"
                name="mode"
                onChange={(e) => inputHandleChange(e)}
                checked={newState.mode == 1}
                value={1}
              />{" "}
              Self
              <br />
              <input
                id="first_name"
                type="radio"
                name="mode"
                onChange={(e) => inputHandleChange(e)}
                checked={newState.mode == 2}
                value={2}
              />{" "}
              COD
            </div>
            {newState.mode == 2 ? (
              <div className="col-md-12 mb-3">
                <label for="email">COD Wallet Balance: </label>
                {" " + newState.cod_wallet_balance}
              </div>
            ) : (
              ""
            )}
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="secondary"
            onClick={() => setModalState({ show: false })}
          >
            Cancel
          </Button>
          <Button variant="primary" onClick={() => submitAddWalet()}>
            Pay
          </Button>
        </Modal.Footer>
      </Modal>

      <Modal show={passwordmodal.show} onHide={() => closeModalpassword()}>
        <Modal.Header closeButton>
          <Modal.Title>Create Temp Password</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="row">
            <div className="col-md-12 mb-3">
              <label for="email">Password</label>
              <input
                className="form-control"
                id="first_name"
                type="text"
                placeholder=""
                name="password"
                value={passwordstate.password}
                onChange={(e) => passwordchange(e)}
                required
              />
              {/* <span>*Please fill </span> */}
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => closeModalpassword()}>
            Cancel
          </Button>

          <Button variant="primary" onClick={() => submitPassword()}>
            Create Password
          </Button>
        </Modal.Footer>
      </Modal>
      {/* <?php
            include('header.php');
        ?>

        <?php
            include('left_nav.php');
        ?> */}
      <Left_panel isSidebarOpen={isSidebarOpen} toggleSidebar={toggleSidebar} />
      <section class="home-section">
        {/* <?php
            include('sub_header.php');
            ?> 
         */}
        <Sub_header />
        <div class="row my-4">
          <div class="col-12 col-md">
            <div class="d-flex">
              <div class="back_btn_wrap">
                <a
                  href={`/customers?type=${
                    state.user_info.user_type == 5 ? 5 : 1
                  }`}
                  class="back_btn"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    data-lucide="corner-up-left"
                    class="lucide lucide-corner-up-left"
                  >
                    <polyline points="9 14 4 9 9 4"></polyline>
                    <path d="M20 20v-7a4 4 0 0 0-4-4H4"></path>
                  </svg>
                </a>
              </div>
              <div class="">
                <h2>
                  {state.user_info.user_type == 5
                    ? "Franchise Information"
                    : "Client Information"}
                </h2>
              </div>
            </div>
          </div>
          <div class="col-12 col-md-2 text-end"></div>
          <div class="col-12 col-md-2 text-end basic_status">
            {state.user_info.status == 1 ? (
              <span class="status active">
                {" "}
                <i class="fa fa-check" aria-hidden="true"></i> Active
              </span>
            ) : state.user_info.status == 2 ? (
              <span class="status active">
                {" "}
                <i class="fa fa-check" aria-hidden="true"></i> Inactive
              </span>
            ) : state.user_info.status == 3 ? (
              <span class="status active">
                {" "}
                <i class="fa fa-check" aria-hidden="true"></i> Suspended
              </span>
            ) : state.user_info.status == 4 ? (
              <span class="status active">
                {" "}
                <i class="fa fa-check" aria-hidden="true"></i> Deleted
              </span>
            ) : (
              ""
            )}
          </div>
        </div>

        <div class="row mt-3 cust_info_box">
          <div class="col-12 col-md-3">
            <div class="card border-0 mb-3">
              <div class="card-body">
                <div class="cust_profile_head">
                  <figure>
                    <img src="../../assets/img/profile.png" class="img-fluid" />
                  </figure>
                  <h2>
                    {state.user_info.full_name}{" "}
                    <small data-bs-toggle="tooltip" title="Verified">
                      <i
                        class="fa fa-check-circle text-primary"
                        aria-hidden="true"
                      ></i>
                    </small>
                  </h2>
                  <small>
                    {state.user_info.company_name
                      ? state.user_info.company_name
                      : ""}
                  </small>
                </div>
                <div class="cust_profile_list_i">
                  <ul class="d-flex justify-content-center">
                    <li>
                      <a
                        href={`mailto:${state.user_info.email}`}
                        data-bs-toggle="tooltip"
                        title={`${state.user_info.email}`}
                      >
                        <span>
                          <i class="fa fa-envelope-o" aria-hidden="true"></i>
                        </span>
                        <h6>Email</h6>
                      </a>
                    </li>
                    <li>
                      <a
                        href={`call:${state.user_info.mobile}`}
                        data-bs-toggle="tooltip"
                        title={`${state.user_info.mobile}`}
                      >
                        <span>
                          <i class="fa fa-phone" aria-hidden="true"></i>
                        </span>
                        <h6>Call</h6>
                      </a>
                    </li>
                  </ul>
                </div>

                <div class="mb-3 text-center">
                  <small>
                    Account current status is{" "}
                    {state.user_info.status == 1 ? (
                      <strong class="text-success">Active</strong>
                    ) : state.user_info.status == 2 ? (
                      <strong class="text-success">Inactive</strong>
                    ) : state.user_info.status == 3 ? (
                      <strong class="text-success">Suspended</strong>
                    ) : state.user_info.status == 4 ? (
                      <strong class="text-success">Deleted</strong>
                    ) : (
                      ""
                    )}
                  </small>
                </div>
                <div class="mb-1">
                  <div class="d-flex">
                    <div class="p-3">
                      <i class="bx bx-wallet"></i>
                    </div>
                    <div class="ps-2 ">
                      <small class="text-muted">Wallet Balance</small>
                      <p>
                        <a href="">
                          ₹
                          {state.user_info.wallet_balance
                            ? state.user_info.wallet_balance.toFixed(2)
                            : 0}
                        </a>
                      </p>
                    </div>
                  </div>
                </div>
                <div class="mb-1">
                  <div class="d-flex">
                    <div class="p-3">
                      <i class="bx bx-wallet"></i>
                    </div>
                    <div class="ps-2 ">
                      <small class="text-muted">COD Wallet Balance</small>
                      <p>
                        <a href="">
                          ₹
                          {state.user_info.cod_wallet_balance
                            ? state.user_info.cod_wallet_balance.toFixed(2)
                            : 0}
                        </a>
                      </p>
                    </div>
                  </div>
                </div>
                <div class="mb-1">
                  <div class="d-flex">
                    <div class="p-3">
                      <i class="bx bx-money"></i>
                    </div>
                    <div class="ps-2 ">
                      <small class="text-muted">Available Credit Limit</small>
                      <p>
                        <a href="">
                          ₹
                          {state.user_info.wallet_balance < 0 &&
                          state.user_info.credit_limit
                            ? Number(state.user_info.wallet_balance) +
                              Number(state.user_info.credit_limit)
                            : state.user_info.credit_limit || 0}
                        </a>
                      </p>
                    </div>
                  </div>
                </div>

                <div class="mb-1">
                  <div class="d-flex">
                    <div class="p-3">
                      <i class="bx bx-calendar"></i>
                    </div>
                    <div class="ps-2 ">
                      <small class="text-muted">On Boarding Date</small>
                      <p>
                        {" "}
                        <Moment format="MMM DD YYYY hh:mm a">
                          {new Date(state.user_info.created * 1000)}
                        </Moment>
                      </p>
                    </div>
                  </div>
                </div>
                <div class="d-grid">
                  <a
                    onClick={() => addMoneyWallet(state.user_info)}
                    class="btn btn-primary btn-block"
                  >
                    Update Wallet
                  </a>
                </div>
                <hr />
                <h5>Other Information</h5>
                <div class="mb-2">
                  <h6 class="mb-2 p-0">Referred By</h6>
                  <small>
                    {state.user_info.jp_full_name
                      ? state.user_info.jp_full_name
                      : ""}{" "}
                    {state.user_info.referred_jp_id
                      ? state.user_info.referred_jp_id
                      : ""}{" "}
                    <a
                      href="#"
                      data-bs-toggle="modal"
                      data-bs-target="#Mobile_Referred"
                    >
                      <i class="bx bx-pencil"></i>
                    </a>
                  </small>
                </div>
                <div class="mb-2">
                  <h6 class="mb-2 p-0">Account Manager</h6>
                  <small>
                    {state.user_info.am_full_name
                      ? state.user_info.am_full_name
                      : ""}{" "}
                    {state.user_info.am_id ? state.user_info.am_id : ""}{" "}
                    <a
                      href="#"
                      data-bs-toggle="modal"
                      data-bs-target="#Mobile_Account"
                    >
                      <i class="bx bx-pencil"></i>
                    </a>
                  </small>
                </div>
                <div class="mb-2">
                  <h6 class="mb-2 p-0">NDR Manager</h6>
                  <small>
                    {state.user_info.ndr_full_name
                      ? state.user_info.ndr_full_name
                      : ""}{" "}
                    {state.user_info.ndr_id ? state.user_info.ndr_id : ""}{" "}
                    <a
                      href="#"
                      data-bs-toggle="modal"
                      data-bs-target="#Mobile_NDR_Manger"
                    >
                      <i class="bx bx-pencil"></i>
                    </a>
                  </small>
                </div>

                <hr />
                <div class="cust_profile_left_info">
                  <h5>Company Name</h5>
                  <h6>
                    {state.user_info.company_name
                      ? state.user_info.company_name
                      : ""}
                  </h6>

                  <h5>Full Name</h5>
                  <h6>{state.user_info.full_name}</h6>

                  <h5>Email</h5>
                  <h6>{state.user_info.email}</h6>

                  <h5>Phone</h5>
                  <h6>{state.user_info.mobile}</h6>

                  <h5>Address</h5>
                  <h6>
                    {state.user_info.address ? state.user_info.address : ""}
                  </h6>

                  <h5>Country</h5>
                  <h6>
                    {state.user_info.country_name
                      ? state.user_info.country_name
                      : ""}
                  </h6>

                  <h5>State</h5>
                  <h6>
                    {state.user_info.state_name
                      ? state.user_info.state_name
                      : ""}
                  </h6>

                  <h5>City</h5>
                  <h6>
                    {state.user_info.city_name ? state.user_info.city_name : ""}
                  </h6>
                </div>
              </div>
            </div>
          </div>
          <div class="col-12 col-md">
            <ul class="nav nav-tabs mb-1">
              <li class="nav-item">
                <a class="nav-link active" data-bs-toggle="tab" href="#panel_1">
                  {state.user_info.user_type == 5
                    ? "Franchise Information"
                    : "Client Information"}
                </a>
              </li>
              <li class="nav-item">
                <a class="nav-link" data-bs-toggle="tab" href="#panel_2">
                  KYC Settings
                </a>
              </li>
              <li class="nav-item">
                <a class="nav-link" data-bs-toggle="tab" href="#panel_3">
                  Credit Settings
                </a>
              </li>
              <li class="nav-item">
                <a class="nav-link" data-bs-toggle="tab" href="#panel_4">
                  Insights
                </a>
              </li>
              <li class="nav-item">
                <a class="nav-link" data-bs-toggle="tab" href="#panel_5">
                  VAS Settings
                </a>
              </li>
            </ul>

            {/* <!-- Tab panes --> */}
            <div class="tab-content">
              <div class="tab-pane  active" id="panel_1">
                <section id="generalinfo">
                  <div class="row">
                    <div class="col-12 col-xl-12">
                      <div class="card card-body border-0  mb-4">
                        <h2 class="h5 my-4">
                          {state.user_info.user_type == 5
                            ? "Franchise Information"
                            : "Client Information"}
                        </h2>
                        <form>
                          <div class="row">
                            <div class="col-md-6 mb-3">
                              <div>
                                <label for="first_name">Full Name</label>
                                <input
                                  class="form-control"
                                  id="first_name"
                                  type="text"
                                  placeholder="name"
                                  required
                                  value={state.user_info.full_name}
                                  onChange={(e) => inputEditHandleChange(e)}
                                  name="full_name"
                                />
                              </div>
                            </div>

                            <div class="col-md-6 mb-3">
                              <div>
                                <label for="first_name">Company Name</label>
                                <input
                                  class="form-control"
                                  id="first_name"
                                  type="text"
                                  placeholder="name"
                                  required
                                  value={state.user_info.company_name}
                                  onChange={(e) => inputEditHandleChange(e)}
                                  name="company_name"
                                />
                              </div>
                            </div>
                          </div>
                          <div class="row">
                            <div class="col-md-6 mb-3">
                              <div class="form-group">
                                <label for="email">Email</label>
                                <input
                                  class="form-control"
                                  id="email"
                                  type="email"
                                  placeholder="name@company.com"
                                  required
                                  value={state.user_info.email}
                                  onChange={(e) => inputEditHandleChange(e)}
                                  name="email"
                                />
                              </div>
                            </div>
                            <div class="col-md-6 mb-3">
                              <div class="form-group">
                                <label for="phone">Phone</label>
                                <input
                                  class="form-control"
                                  id="phone"
                                  type="text"
                                  placeholder="Enter phone"
                                  required
                                  value={state.user_info.mobile}
                                  onChange={(e) => inputEditHandleChange(e)}
                                  name="mobile"
                                />
                              </div>
                            </div>
                          </div>
                          {state.user_info.user_type == 5 ? (
                            <>
                              <h2 class="h5 my-4">Commission</h2>
                              <div class="row">
                                <div class="col-sm-6 mb-3">
                                  <div class="form-group">
                                    <label for="commission">
                                      Franchise Commission
                                    </label>
                                    <input
                                      class="form-control"
                                      type="number"
                                      placeholder="Enter Commission"
                                      required
                                      value={state.user_info.price_commission}
                                      onChange={(e) => inputEditHandleChange(e)}
                                      name="price_commission"
                                    />
                                  </div>
                                </div>
                              </div>
                            </>
                          ) : (
                            <>
                              <h2 class="h5 my-4">Discount</h2>
                              <div class="row">
                                <div class="col-sm-6 mb-3">
                                  <div class="form-group">
                                    <label for="address">
                                      Customer Discount
                                    </label>
                                    <input
                                      class="form-control"
                                      type="number"
                                      placeholder="Enter Discount"
                                      required
                                      value={state.user_info.price_discount}
                                      onChange={(e) => inputEditHandleChange(e)}
                                      name="price_discount"
                                    />
                                  </div>
                                </div>
                              </div>
                              <h2 class="h5 my-4">Current Aggregator</h2>
                              <div class="row">
                                <div class="col-sm-6 mb-3">
                                  <div class="form-group">
                                    <label for="address">
                                      Current Aggregator
                                    </label>
                                    <input
                                      class="form-control"
                                      disabled
                                      value={
                                        state.user_info.aggregator
                                          ? state.user_info.aggregator
                                          : ""
                                      }
                                    />
                                  </div>
                                </div>
                              </div>
                            </>
                          )}

                          <h2 class="h5 my-4">Location</h2>
                          <div class="row">
                            <div class="col-sm-12 mb-3">
                              <div class="form-group">
                                <label for="address">Address</label>
                                <input
                                  class="form-control"
                                  id="address"
                                  type="text"
                                  placeholder="Enter your home address"
                                  required
                                  value={state.user_info.address}
                                  onChange={(e) => inputEditHandleChange(e)}
                                  name="address"
                                />
                              </div>
                            </div>
                            <div class="col-sm-4 mb-3">
                              <label for="" class="form-label">
                                Country <span class="text-danger">*</span>
                              </label>
                              <select
                                class="form-select w-100 mb-0"
                                id="state"
                                name="country"
                                aria-label="State select example"
                                onChange={(e) => handleSelectCountry(e)}
                                value={state.user_info.country || ""}
                              >
                                <option>Country</option>

                                {countrylist.map((sub) => (
                                  <option value={sub.country_id}>
                                    {sub.country_name}
                                  </option>
                                ))}
                              </select>
                            </div>
                            <div class="col-sm-4 mb-3">
                              <label for="" class="form-label">
                                State <span class="text-danger">*</span>
                              </label>
                              <select
                                class="form-select w-100 mb-0"
                                id="state"
                                name="state"
                                aria-label="State select example"
                                onChange={(e) => handleSelectState(e)}
                                value={state.user_info.state || ""}
                              >
                                <option>State</option>
                                {statelist.map((sub) => (
                                  <option value={sub.state_id}>
                                    {sub.state_name}
                                  </option>
                                ))}
                              </select>
                            </div>
                            <div class="col-sm-4 mb-3">
                              <label for="" class="form-label">
                                City <span class="text-danger">*</span>
                              </label>
                              <select
                                class="form-select w-100 mb-0"
                                id="state"
                                name="city"
                                aria-label="State select example"
                                onChange={(e) => handleSelectCity(e)}
                                value={state.user_info.city || ""}
                              >
                                <option>City</option>

                                {citylist.map((sub) => (
                                  <option value={sub.city_id}>
                                    {sub.city_name}
                                  </option>
                                ))}
                              </select>
                            </div>
                          </div>

                          <h2 class="h5 my-4">Update Password</h2>
                          <div class="row">
                            <div class="col-12 col-md-6">
                              <label for="">Update Password</label>
                              <input
                                type="text"
                                class="form-control"
                                id="text"
                                placeholder="enter new password"
                                name="password"
                                onChange={(e) => inputEditHandleChange(e)}
                              />
                            </div>
                          </div>

                          <div class="mt-3">
                            <button
                              class="btn btn-gray-800 mt-2 animate-up-2"
                              type="button"
                              onClick={() => updateUsersInfo()}
                            >
                              Save
                            </button>
                          </div>
                        </form>
                      </div>
                    </div>
                  </div>
                </section>
              </div>
              <div class="tab-pane  fade" id="panel_2">
                <section id="generalinfo">
                  <div class="row">
                    <div class="col-12 col-xl-12">
                      <div class="card card-body border-0  mb-4">
                        <form>
                          <h2 class="h5 my-4">KYC Inforamtion</h2>
                          <div class="row ">
                            {/* <div class="col-12 col-md">
                                                            <label class="form-check-label" for="inlineRadio2">Verified</label>
                                                        </div> */}
                            <div class="col-12 col-md-4">
                              {/* <div class="form-check form-switch  ">
                                                               <input class="form-check-input" type="checkbox" role="switch" id="flexSwitchCheckChecked" checked/>
                                                               <label class="form-check-label" for="flexSwitchCheckChecked">Verified</label>
                                                            </div> */}
                            </div>
                          </div>
                          <div class="row mb-3">
                            <div class="col-12 col-md">
                              <label
                                class="form-check-label"
                                for="inlineRadio2"
                              >
                                Aadhar Number
                              </label>
                              <input
                                type="text"
                                class="form-control"
                                id="text"
                                placeholder="Enter details name"
                                value={
                                  state.user_info.aadhaar_number
                                    ? state.user_info.aadhaar_number
                                    : ""
                                }
                                disabled
                              />
                            </div>
                            <div class="col-12 col-md-4">
                              {/* <div class="form-check form-switch  pt-4">
                                                               <input class="form-check-input" type="checkbox" role="switch" id="flexSwitchCheckChecked" checked/>
                                                               <label class="form-check-label" for="flexSwitchCheckChecked">Verified</label>
                                                            </div> */}
                            </div>
                          </div>
                          <div class="row">
                            <div class="col-12 col-md">
                              <label
                                class="form-check-label"
                                for="inlineRadio2"
                              >
                                GST Number
                              </label>
                              <input
                                type="text"
                                class="form-control"
                                id="text"
                                placeholder="Enter details name"
                                value={
                                  state.user_info.gst_number
                                    ? state.user_info.gst_number
                                    : ""
                                }
                                disabled
                              />
                            </div>
                            <div class="col-12 col-md-4">
                              {/* <div class="form-check form-switch  pt-4">
                                                               <input class="form-check-input" type="checkbox" role="switch" id="flexSwitchCheckChecked" checked/>
                                                               <label class="form-check-label" for="flexSwitchCheckChecked">Verified</label>
                                                            </div> */}
                            </div>
                          </div>

                          {/* <div class="mt-3">
                                                        <button class="btn btn-gray-800 mt-2 animate-up-2" type="submit">Save</button>
                                                    </div> */}
                        </form>
                      </div>
                    </div>
                  </div>
                </section>
              </div>
              <div class="tab-pane  fade" id="panel_3">
                <section id="generalinfo">
                  <div class="row">
                    <div class="col-12 col-xl-12">
                      <div class="card card-body border-0  mb-4">
                        <form>
                          <h2 class="h5 my-4">Credit Settings</h2>
                          <div class="row ">
                            {/* <div class="col-12 col-md">
                                                            <div class="d-flex justify-content-between">
                                                                <div class="">
                                                                    <label for="email" class="form-label">Credit Limit:</label>
                                                                </div>
                                                              
                                                            </div>
                                                            <div class="input-group">
                                                                <span class="input-group-text">INR</span>
                                                                <input type="text" class="form-control" placeholder="Enter credit amount" name="credit_limit" disabled onChange={(e)=>handlecreditlimit(e)} value={state.user_info.credit_limit?state.user_info.credit_limit:""}/>
                                                              </div>
                                                        </div> */}

                            <div class="col-12 col-md">
                              <div class="d-flex justify-content-between">
                                <div class="">
                                  <label for="email" class="form-label">
                                    Credit Limit Range:
                                  </label>
                                </div>
                              </div>
                              <div class="input-group">
                                <span class="input-group-text">INR</span>
                                <input
                                  type="text"
                                  class="form-control"
                                  placeholder="Enter credit amount"
                                  name="credit_limit_range"
                                  onChange={(e) => handlecreditlimit(e)}
                                  value={
                                    state.user_info.credit_limit_range ?? ""
                                  }
                                />
                              </div>
                              <small className="mt-1">
                                {" "}
                                Updating the credit limit will reset the current
                                used and available credit values
                              </small>
                            </div>
                          </div>

                          <div class="mt-3">
                            <button
                              class="btn btn-gray-800 mt-2 animate-up-2"
                              type="button"
                              onClick={() => setCreditlimit()}
                            >
                              Save
                            </button>
                          </div>
                        </form>
                      </div>
                    </div>
                  </div>
                </section>
              </div>
              <div className="tab-pane fade show active" id="panel_4">
                <section id="generalinfo">
                  <div className="row">
                    <div className="col-12 col-xl-12">
                      <div className="card card-body border-0 mb-4">
                        <h2 className="h5">Customer Insights</h2>

                        <div className="input-group mb-3">
                          {/* Month Dropdown */}
                          <select
                            className="form-select"
                            value={month}
                            onChange={(e) => setMonth(e.target.value)}
                          >
                            <option value="">Select Month</option>
                            {[
                              "January",
                              "February",
                              "March",
                              "April",
                              "May",
                              "June",
                              "July",
                              "August",
                              "September",
                              "October",
                              "November",
                              "December",
                            ].map((m, i) => (
                              <option key={i} value={m}>
                                {m.slice(0, 3)}
                              </option>
                            ))}
                          </select>

                          {/* Year Dropdown */}
                          <select
                            className="form-select"
                            value={year}
                            onChange={(e) => setYear(e.target.value)}
                          >
                            {[...Array(6)].map((_, i) => {
                              const dynamicYear =
                                new Date().getFullYear() - 1 + i; // start from previous year
                              return (
                                <option key={dynamicYear} value={dynamicYear}>
                                  {dynamicYear}
                                </option>
                              );
                            })}
                          </select>

                          {/* Submit Button */}
                          <button
                            className="btn btn-primary"
                            onClick={fetchData}
                          >
                            Submit
                          </button>
                        </div>

                        {/* Message Before Data is Loaded */}
                        {message && <p className="text-center">{message}</p>}

                        {/* Loader */}
                        {loading && <p className="text-center">Loading...</p>}

                        {/* Show Data After Loading */}
                        {!loading && shipmentData && (
                          <div className="row">
                            <InfoCard
                              title="Monthly Delivered Order Count"
                              value={shipmentData.totalDelivered}
                            />
                            <InfoCard
                              title="Prepaid vs COD Delivered %"
                              value={`PPD ${shipmentData.prepaidPercentage}% COD ${shipmentData.codPercentage}%`}
                            />
                            <InfoCard
                              title="Monthly COD Collection"
                              value={`₹${shipmentData.monthlyCodCollection}`}
                            />
                            <InfoCard
                              title="Monthly Invoice Value (Delivered Orders)"
                              value={`₹${shipmentData.monthlyInvoice}`}
                            />
                            <InfoCard
                              title="Monthly Ratio: Invoice Value to COD Collection"
                              value={shipmentData.invoiceToCODRatio.toFixed(2)}
                            />
                            <InfoCard
                              title="Average COD Value"
                              value={shipmentData.averageCodValue.toFixed(2)}
                            />
                            <InfoCard
                              title="Average Invoice Value"
                              value={shipmentData.averageInvoiceValue.toFixed(
                                2
                              )}
                            />
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                </section>
              </div>

              <div class="tab-pane  fade" id="panel_5">
                <section id="generalinfo">
                  <div class="row">
                    <div class="col-12 col-xl-12">
                      <div className="card card-body border-0 mb-4">
                        <h2 className="h5 mb-4">Seller Subscription</h2>

                        <div className="row mb-4">
                          <div className="col-md-3">
                            <label className="form-label fw-bold">
                              Current Plan
                            </label>
                            <input
                              className="form-control"
                              disabled
                              value={subscription.plan_name || ""}
                            />
                          </div>

                          <div className="col-md-3">
                            <label className="form-label fw-bold">
                              Custom Pricing
                            </label>

                            <input
                              className={`form-control fw-bold ${
                                subscription.is_custom
                                  ? "text-warning"
                                  : "text-success"
                              }`}
                              disabled
                              value={subscription.is_custom ? "Yes" : "No"}
                            />
                          </div>

                          {/* <div className="col-md-3">
        <label className="form-label fw-bold">
            Monthly Price
        </label>

        <div className="input-group">
            <span className="input-group-text">₹</span>

            <input
                className="form-control"
                type="number"
                name="monthly_price"
                value={subscription.monthly_price}
                onChange={handleSubscriptionChange}
            />
        </div>
    </div> */}

                          <div className="col-md-3">
                            <label className="form-label fw-bold">
                              Free Orders
                            </label>

                            <div className="input-group">
                              <span className="input-group-text">#</span>

                              <input
                                className="form-control"
                                type="number"
                                name="free_orders"
                                value={subscription.free_orders}
                                onChange={handleSubscriptionChange}
                              />
                            </div>
                          </div>
                        </div>

                        <hr />

                        <h5 className="mb-3">Value Added Service Pricing</h5>

                        <div className="row">
                          {[
                            {
                              label: "AfterShip Premium",
                              name: "delivery_update_price",
                            },

                            {
                              label: "Product Image based COD Verification",
                              name: "cod_verification_price",
                            },

                            {
                              label: "TrueReach™ COD Shield",
                              name: "cod_shield_price",
                            },

                            {
                              label: "TrueReach™ RTO Shield",
                              name: "rto_shield_price",
                            },

                            {
                              label: "TrueWeight™ Shield",
                              name: "trueweight_price",
                            },
                          ].map((item) => (
                            <div className="col-md-4 mb-3" key={item.name}>
                              <label className="form-label">{item.label}</label>

                              <div className="input-group">
                                <span className="input-group-text">₹</span>

                                <input
                                  type="number"
                                  className="form-control"
                                  name={item.name}
                                  value={subscription[item.name]}
                                  onChange={handleSubscriptionChange}
                                />
                              </div>
                            </div>
                          ))}
                        </div>

                        <div className="mt-3">
                          <button
                            className="btn btn-warning"
                            onClick={updateCustomPricing}
                          >
                            Save Custom Pricing
                          </button>
                        </div>
                      </div>

                      <div className="row">
                        <div className="col-6 md">
                          <div className="card data_table mb-3 mb_display_none">
                            <div className="card-body ">
                              <h2 class="h5 mt-1">Selected Language</h2>
                              <input
                                className="form-control"
                                disabled
                                value={state.user_info.ivr_language ?? ""}
                              ></input>
                            </div>
                          </div>
                        </div>
                        <div className="col-6 md">
                          <div className="card data_table mb-3 mb_display_none">
                            <div className="card-body ">
                              <h2 class="h5 mt-1">Assign Number</h2>
                              <div className="row">
                                <div className="col-8 md">
                                  <input
                                    className="form-control"
                                    type="number"
                                    name="ivr_number"
                                    value={state.user_info.ivr_number ?? ""}
                                    onChange={(e) => handleivrNumber(e)}
                                  ></input>
                                </div>
                                <div className="col-4 md">
                                  <button
                                    onClick={(e) => updateIvrNumber(e)}
                                    className="btn btn-primary"
                                    disabled={
                                      state.user_info.ivr_number_requested ==
                                        undefined ||
                                      state.user_info.ivr_number_requested === 0
                                    }
                                  >
                                    Save
                                  </button>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="col-6 md">
                          <div className="card data_table mb-3 mb_display_none">
                            <div className="card-body ">
                              <h2 class="h5 mt-1">Brand Name</h2>
                              <input
                                className="form-control"
                                disabled
                                value={state.user_info.brand_name ?? ""}
                              ></input>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div className="card data_table mb-3 mb_display_none">
                        <div className="card-body">
                          <div className="table-responsive">
                            <div className="shipm_tablew rounded-3">
                              <table className="table table-striped table-hover m-0 table-xl">
                                <thead>
                                  <tr>
                                    <th>Value Added Services</th>
                                    <th>Charges</th>
                                    <th>Status</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  {[
                                    {
                                      label:
                                        "Delivery Alerts on WhatsApp with Product Image",
                                      key: "delivery_updates",
                                      original: `₹${subscription.delivery_update_price}`,
                                    },
                                    // { label: 'Complete NDR Management with Audio Playback and Refund Guarantee', key: 'human_ndr', original: '₹12.99', final: '₹0' },
                                    {
                                      label:
                                        "COD Verification with Product Image",
                                      key: "cod_verification",
                                      original: `₹${subscription.cod_verification_price}`,
                                    },
                                  ].map((service) => (
                                    <tr key={service.key}>
                                      <td>{service.label}</td>
                                      <td className="fw-bold">
                                        {" "}
                                        {service.original}
                                      </td>
                                      <td>
                                        <div className="d-flex justify-content-start">
                                          <div>
                                            <div className="form-check form-switch mb-2">
                                              <input
                                                className="form-check-input"
                                                type="checkbox"
                                                role="switch"
                                                checked={vasStatus[service.key]}
                                                onChange={() =>
                                                  handleToggle(service.key)
                                                }
                                              />
                                            </div>
                                          </div>
                                          <div>
                                            <span
                                              className={`badge ${
                                                vasStatus[service.key]
                                                  ? "bg-success"
                                                  : "bg-danger"
                                              }`}
                                            >
                                              {vasStatus[service.key]
                                                ? "On"
                                                : "Off"}
                                            </span>
                                          </div>
                                        </div>
                                      </td>
                                    </tr>
                                  ))}
                                </tbody>
                              </table>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div className="card data_table mb-3 mb_display_none">
                        <div className="card-body">
                          <div className="table-responsive">
                            <div className="shipm_tablew rounded-3">
                              <table className="table table-striped table-hover m-0 table-xl">
                                <thead>
                                  <tr>
                                    <th>TrueReach™ - Value Added Services</th>
                                    <th>
                                      {vasStatus.ivr_number_requested === 0 &&
                                        // <button
                                        //   className="btn btn-primary"
                                        //   onClick={() => setShowActivatePopup(true)}
                                        // >
                                        //   Activate this Service
                                        // </button>
                                        ""}

                                      {vasStatus.ivr_number_requested === 1 && (
                                        <button
                                          className="btn btn-secondary"
                                          disabled
                                        >
                                          Service Requested
                                        </button>
                                      )}

                                      {vasStatus.ivr_number_requested === 2 && (
                                        <div className="fw-bold text-success">
                                          Dedicated Number –{" "}
                                          {vasStatus.ivr_number} –{" "}
                                          {vasStatus.ivr_language}
                                        </div>
                                      )}
                                    </th>
                                    <th>Charges</th>
                                    <th>Status</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  {[
                                    {
                                      label: "TrueReach™ - COD Shield",
                                      key: "cod_shield",
                                      original: `₹${subscription.cod_shield_price}`,
                                    },
                                    // { label: 'Complete NDR Management with Audio Playback and Refund Guarantee', key: 'human_ndr', original: '₹12.99', final: '₹0' },
                                    {
                                      label: "True Reach™ - RTO Shield",
                                      key: "rto_shield",
                                      original: `₹${subscription.rto_shield_price}`,
                                    },
                                  ].map((service) => (
                                    <tr key={service.key}>
                                      <td>{service.label}</td>
                                      <td></td>
                                      <td className="fw-bold">
                                        {" "}
                                        {service.original}
                                      </td>
                                      <td>
                                        <div className="d-flex justify-content-start">
                                          <div>
                                            <div className="form-check form-switch mb-2">
                                              <input
                                                className="form-check-input"
                                                type="checkbox"
                                                role="switch"
                                                checked={vasStatus[service.key]}
                                                disabled={
                                                  vasStatus.ivr_number_requested !==
                                                  2
                                                }
                                                onChange={() =>
                                                  handleToggle(service.key)
                                                }
                                              />
                                            </div>
                                          </div>
                                          <div>
                                            <span
                                              className={`badge ${
                                                vasStatus[service.key]
                                                  ? "bg-success"
                                                  : "bg-danger"
                                              }`}
                                            >
                                              {vasStatus[service.key]
                                                ? "On"
                                                : "Off"}
                                            </span>
                                          </div>
                                        </div>
                                      </td>
                                    </tr>
                                  ))}
                                </tbody>
                              </table>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </section>
              </div>
            </div>
          </div>
          <div class="col-12 col-md-3">
            <div class="card border-0 mb-3">
              <div class="card-body">
                <div class="d-grid mb-3">
                  <a
                    class="btn btn-light-o btn-block"
                    onClick={() => addMoneyWallet(state.user_info)}
                  >
                    Update Wallet
                  </a>
                </div>
                {/* <div class="d-grid mb-3">
                                    <a href="" class="btn btn-light-o btn-block">Add Money from COD W to Wallet</a>
                                </div> */}
                <div class="d-grid mb-3">
                  <a
                    href={`/products/${state.user_info.customer_id}`}
                    class="btn btn-light-o btn-block"
                  >
                    Set Custom Pricing
                  </a>
                </div>
                <div class="d-grid mb-3">
                  <a
                    href={`/master_new_customer/${state.user_info.customer_id}`}
                    class="btn btn-light-o btn-block"
                  >
                    Set Dedicated Carrier Code
                  </a>
                </div>
                <div class="d-grid mb-3">
                  <a
                    onClick={(e) => openpasswordModal(state.user_info)}
                    class="btn btn-light-o btn-block"
                  >
                    Create Temp Password access
                  </a>
                </div>
                <div class="d-grid mb-3">
                  <a
                    onClick={(e) => skip_kyc(state.user_info)}
                    class="btn btn-light-o btn-block"
                  >
                    Skip Kyc
                  </a>
                </div>
                <div class="d-grid mb-3">
                  <a
                    onClick={() => addCreditnote(state.user_info)}
                    class="btn btn-light-o btn-block"
                  >
                    Issue Credit Note
                  </a>
                </div>
                {/* <div class="d-grid mb-3">
                                <button
    type="button"
    className="btn btn-light-o btn-block"
    data-bs-toggle="modal"
    data-bs-target="#bulkPricingUploadModalCustomer"
  >
    Upload Bulk Pricing
  </button>
                                </div> */}
              </div>
            </div>

            <div
              className="modal fade"
              id="bulkPricingUploadModalCustomer"
              tabIndex="-1"
              aria-hidden="true"
              data-bs-backdrop="false"
            >
              <div className="modal-dialog modal-dialog-centered">
                <div className="modal-content">
                  <div className="modal-header">
                    <h5 className="modal-title">Upload Bulk Pricing Excel</h5>

                    <button
                      type="button"
                      className="btn-close"
                      data-bs-dismiss="modal"
                    ></button>
                  </div>

                  <div className="modal-body">
                    <div className="mb-3">
                      <label className="form-label">Select Excel File</label>

                      <input
                        type="file"
                        className="form-control"
                        accept=".xlsx,.xls"
                        onChange={(e) => {
                          setBulkPricingFile(e.target.files[0]);
                        }}
                      />
                    </div>
                    <div className="mb-3">
                      <button
                        className="btn btn-danger mt-2 mb-2"
                        onClick={downloadExcel}
                      >
                        Download Excel
                      </button>
                    </div>

                    <div className="alert alert-info">
                      Please upload the same downloaded pricing sheet.
                    </div>
                  </div>

                  <div className="modal-footer">
                    <button
                      type="button"
                      className="btn btn-secondary"
                      data-bs-dismiss="modal"
                    >
                      Close
                    </button>

                    <button
                      type="button"
                      className="btn btn-success"
                      onClick={uploadBulkPricingExcel}
                      disabled={bulkPricingLoading}
                    >
                      {bulkPricingLoading
                        ? "Uploading..."
                        : "Upload & Continue"}
                    </button>
                  </div>
                </div>
              </div>
            </div>
            {/* <div class="card border-0 mb-3 cust_profile_rg_stat_bx">
                          <div class="card-body">
                                <div class="card mb-3">
                                <div class="card-body">
                                    <div class="row d-block d-xl-flex align-items-center">
                                        <div class="col-6 col-xl-5 text-xl-center mb-3 mb-xl-0 d-flex align-items-center justify-content-xl-center">
                                            <div class="icon-shape icon-shape-primary-o rounded me-4 me-sm-0">
                                                <i class="fa fa-cube fa-2x" aria-hidden="true"></i>
                                            </div>
                                        </div>
                                        <div class="col-6 col-xl-7 px-xl-0">
                                            <div class="d-none d-sm-block">
                                                <h2 class="h6 text-gray-400 mb-0">Shipments</h2>
                                                <h3 class="mb-2 text-muted">
                                                    <a href="">45k</a>
                                                </h3>
                                            </div> 
                                        </div>
                                    </div>
                                </div>
                                </div>
                                <div class="card mb-3">
                                    <div class="card-body">
                                    <div class="row d-block d-xl-flex align-items-center">
                                        <div class="col-6 col-xl-5 text-xl-center mb-3 mb-xl-0 d-flex align-items-center justify-content-xl-center">
                                            <div class="icon-shape icon-shape-primary-o rounded me-4 me-sm-0">
                                                <i class="fa fa-first-order fa-2x" aria-hidden="true"></i>
                                            </div>
                                        </div>
                                        <div class="col-6 col-xl-7 px-xl-0">
                                            <div class="d-none d-sm-block">
                                                <h2 class="h6 text-gray-400 mb-0">Orders</h2>
                                                <h3 class=" mb-2">
                                                    <a href="">45k</a>
                                                </h3>
                                            </div> 
                                        </div>
                                    </div>
                                    </div>
                                </div>
                                <div class="card mb-3">
                                    <div class="card-body">
                                    <div class="row d-block d-xl-flex align-items-center">
                                        <div class="col-6 col-xl-5 text-xl-center mb-3 mb-xl-0 d-flex align-items-center justify-content-xl-center">
                                            <div class="icon-shape icon-shape-primary-o rounded me-4 me-sm-0">
                                                <i class="fa fa-usd fa-2x" aria-hidden="true"></i>
                                            </div>
                                        </div>
                                        <div class="col-6 col-xl-7 px-xl-0">
                                            <div class="d-none d-sm-block">
                                                <h2 class="h6 text-gray-400 mb-0">Recharges</h2>
                                                <h3 class="mb-2">
                                                    <a href="">$209394</a>
                                                </h3>
                                            </div> 
                                        </div>
                                    </div>
                                    </div>
                                </div>
                            </div>
                        </div> */}
          </div>
        </div>
      </section>

      {/* <?php
include('footer.php');
?>   */}
    </div>
  );
};
const InfoCard = ({ title, value }) => (
  <div className="col-12 col-md-6 mb-3">
    <div className="card border-0 bg-tertiary text-white">
      <div className="card-body">
        <small className="text-muted">{title}</small>
        <p>{value}</p>
      </div>
    </div>
  </div>
);

export default Customers_info;
